// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"e51f1b68","651":"213b996e"}[chunkId] + ".chunk.js";
};